import {IconButton, Tooltip} from '@mui/material';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faHeadphones} from '@fortawesome/pro-duotone-svg-icons';
import {useTheme} from "@mui/material/styles";
import Link from "next/link";

const SupportButton = ({url}: { url: string }) => {
    const theme = useTheme();
    return (
        <Tooltip title="Support" arrow>
            <IconButton size="large" color="inherit">
                <Link href={url}>
                    <FontAwesomeIcon icon={faHeadphones} size={'sm'} color={theme.palette.primary.main}/>
                </Link>
            </IconButton>
        </Tooltip>
    )
};

export default SupportButton;
